import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

const Navbar = () => {
  const { t, language, toggleLanguage } = useLanguage();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    // Changed bg to white and text to dark for a cleaner, professional look
    <nav className="bg-white text-[#1E293B] border-b border-gray-100 shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center h-20">
          
          {/* BRANDING SECTION */}
          <Link to="/" className="flex flex-col items-start group">
            <div className="flex-shrink-0">
              {/* Main Title: Styled to match the red logo image */}
              <h1 
                className="text-2xl sm:text-3xl md:text-4xl font-black leading-none text-[#EB1B1B]" 
                style={{ 
                  fontFamily: 'Noto Serif Kannada, serif',
                  letterSpacing: '-0.02em' 
                }}
              >
                ಕಲ್ಲಿನ ಕೂಗು
              </h1>
              {/* Subtitle: Styled as 'Kannada Daily' in the red logo style */}
              <div className="flex items-center mt-1">
                 <span className="text-[10px] sm:text-xs font-bold text-[#EB1B1B] uppercase tracking-tighter mr-2">
                   Kallina Koogu
                 </span>
                 <span className="text-[10px] sm:text-xs font-medium text-gray-500">
                   ಕನ್ನಡ ದಿನಪತ್ರಿಕೆ
                 </span>
              </div>
            </div>
          </Link>

          {/* NAVIGATION LINKS */}
          <div className="flex items-center space-x-1 md:space-x-2">
            <Link to="/">
              <Button
                variant="ghost"
                className={`text-xs md:text-sm font-bold uppercase tracking-tight px-3 ${
                  isActive('/') ? 'text-[#EB1B1B]' : 'text-gray-600 hover:text-[#EB1B1B] hover:bg-gray-50'
                }`}
              >
                {t('home')}
              </Button>
            </Link>

            <Link to="/archive">
              <Button
                variant="ghost"
                className={`text-xs md:text-sm font-bold uppercase tracking-tight px-3 ${
                  isActive('/archive') ? 'text-[#EB1B1B]' : 'text-gray-600 hover:text-[#EB1B1B] hover:bg-gray-50'
                }`}
              >
                {t('archive')}
              </Button>
            </Link>

            <Link to="/about">
              <Button
                variant="ghost"
                className={`text-xs md:text-sm font-bold uppercase tracking-tight px-3 ${
                  isActive('/about') ? 'text-[#EB1B1B]' : 'text-gray-600 hover:text-[#EB1B1B] hover:bg-gray-50'
                }`}
              >
                {t('aboutUs')}
              </Button>
            </Link>

            <div className="h-6 w-[1px] bg-gray-200 mx-2 hidden sm:block"></div>

            <Button
              variant="ghost"
              size="sm"
              onClick={toggleLanguage}
              className="text-gray-500 hover:text-[#EB1B1B] flex items-center gap-1"
            >
              <Globe className="h-4 w-4" />
              <span className="font-bold text-xs">{language.toUpperCase()}</span>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
